import React, { VFC } from 'react'

type Props = { className?: string }

export const TransitionLinkTextDecoration: VFC<Props> = ({ className }) => {
  return (
    <svg viewBox="0 0 40 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_240_343)">
        <circle cx="29" cy="11" r="10.5" fill="#F2F5F9" />
        <circle cx="29" cy="11" r="2.5" fill="#060E6D" />
        <line x1="0.5" y1="11" x2="28.5" y2="11" stroke="#060E6D" />
      </g>
      <defs>
        <clipPath id="clip0_240_343">
          <rect width="39" height="21" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
